import React from "react";
import styles from "./Card.module.css"; // Importa el CSS para el Card

function Card({ children }) {
  return <div className={styles.card}>{children}</div>;
}

function CardHeader({ children }) {
  return <div className={styles.cardHeader}>{children}</div>;
}

function CardTitle({ children }) {
  return <h3 className={styles.cardTitle}>{children}</h3>;
}

function CardContent({ children }) {
  return <div className={styles.cardContent}>{children}</div>;
}

export { Card, CardHeader, CardTitle, CardContent };